import { render, staticRenderFns } from "./SDSFilter.vue?vue&type=template&id=3073f9b3&scoped=true&"
import script from "./SDSFilter.vue?vue&type=script&lang=js&"
export * from "./SDSFilter.vue?vue&type=script&lang=js&"
import style0 from "./SDSFilter.vue?vue&type=style&index=0&id=3073f9b3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3073f9b3",
  null
  
)

export default component.exports